import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoadingState } from '@/constants/types';

const initialState: LoadingState = {
  isLoading: false,
  backdrop: false,
};

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setBackdropLoading: (state, action: PayloadAction<boolean>) => {
      state.backdrop = action.payload;
    },
    showLoader: (state, action: PayloadAction<{ backdrop?: boolean }>) => {
      state.isLoading = true;
      state.backdrop = action.payload.backdrop || false;
    },
    hideLoader: (state) => {
      state.isLoading = false;
      state.backdrop = false;
    },
  },
});

export const { setLoading, setBackdropLoading, showLoader, hideLoader } = loadingSlice.actions;
export default loadingSlice.reducer;